/** Isolated Standard editor entity reads. Voluum retains its exact POST. For Media Devoted | Created By Ciro Autiero */
import { matchTracker, type TrackerId } from '@trafficpulse/shared';
import api from '@/services/api';
import { queryVoluumTrackerEntity, type VoluumTrackerEntityQueryPayload } from '@/features/flow-optimizer/services/voluum-tracker-entity-api';
export function unwrapEntity(data: unknown): unknown {
  return data !== null && typeof data === 'object' && 'data' in data ? (data as { data: unknown }).data : data;
}
export async function getTcEntity(kind: 'landers' | 'offers', id: string): Promise<unknown> {
  const { data } = await api.get(`/tres-commas/${kind}/${encodeURIComponent(id)}`);
  return unwrapEntity(data);
}
export function queryTrackerEntity(provider: TrackerId | null, payload: VoluumTrackerEntityQueryPayload): Promise<unknown> {
  return matchTracker(provider ?? 'voluum', {
    voluum: () => queryVoluumTrackerEntity(payload),
    binom: () => Promise.resolve(null),
    'tres-commas': async () => ({ entity: await getTcEntity(payload.type === 'LANDER' ? 'landers' : 'offers', payload.id) }),
  });
}
export async function updateTcLander(id: string, body: unknown): Promise<unknown> {
  const { data } = await api.put(`/tres-commas/landers/${encodeURIComponent(id)}`, body);
  return unwrapEntity(data);
}
